/**
 * The line that names where a search looks: « Annecy · 50 km ».
 *
 * Until 28/10/2026 it read « Annecy - 50km »: a hyphen that looks like a
 * minus and a unit glued to its number, the kind of detail that makes the app
 * look like a prototype (design review, recommendation 3). A middle dot
 * separates the place from its radius, and a non-breaking space keeps the
 * number with its unit so « 50 » never ends a line on its own.
 */
export const BETWEEN_PLACE_AND_RADIUS = ' · ';

export function aRadius(radiusKm: number): string {
  return `${radiusKm}\u00a0km`;
}

export function aPlaceAndItsRadius(place: string, radiusKm: number): string {
  return `${place}${BETWEEN_PLACE_AND_RADIUS}${aRadius(radiusKm)}`;
}

/** The place without its radius, for the screens that name the city alone. */
export function thePlaceAlone(line: string | undefined): string | undefined {
  return line?.split(BETWEEN_PLACE_AND_RADIUS)[0];
}
